import { IApiServiceContext, ApiServiceContextState } from '../context/ApiServiceContext';
import { useContext } from 'react';

export const useApiService = () => useContext<ApiServiceContextState>(IApiServiceContext);